import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

const COLORS = {
  inactive: 'danger',
  draft: 'warning',
  published: 'success',
}

export default function BuilderFormatter({ info }) {
  const { row, value: meta } = getInfo(info)
  const status = builderStatus(row, meta)

  return <Badge variant='outline' color={COLORS[status]}>
    {status}
  </Badge>
}

function builderStatus(row, meta) {
  const { version, publishVersion } = meta || {}

  if (!row?.builder && !row?.cmsPostBuilder) {
    return 'inactive'
  }

  if (version && publishVersion && version === publishVersion) {
    return 'published'
  }

  return 'draft'
}
